<template>
  <div
    :class="{
      'source-component': true,
      'clickable-card': props.clickable
    }"
  >
    <div class="icon">
      <AppIcon :name="iconName" :size="iconSize" />
    </div>
    <div class="content">
      <h5>{{ title }}</h5>
      <p class="description">{{ description }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { IconName, IconSize } from '@/models/icon-types';

interface Props {
  title: string;
  description?: string | null;
  iconName?: IconName;
  iconSize?: IconSize;
  clickable: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  description: null,
  iconName: IconName.Document,
  iconSize: IconSize.HeadlineM,
  clickable: false
});
</script>

<style scoped lang="scss">
.source-component {
  display: flex;
  padding: $space-4;
  border: $border;
  border-radius: $radius-2;
  background-color: $color-neutral-0;
  box-shadow: $elevation-1;
  transition: box-shadow 0.2s ease;
  margin-bottom: $space-1;
}

.icon {
  margin-right: $space-4;
}

.content {
  flex: 1;
  overflow-wrap: anywhere;
}

.description {
  overflow: hidden;
  text-overflow: ellipsis;
}

.clickable-card {
  &:hover {
    cursor: pointer;
    box-shadow: $elevation-2;
  }
}
</style>
